import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=9d3d48b2&scoped=true"
import script from "./ItemCard.vue?vue&type=script&lang=js"
export * from "./ItemCard.vue?vue&type=script&lang=js"
import style0 from "./ItemCard.vue?vue&type=style&index=0&id=9d3d48b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3d48b2",
  null
  
)

export default component.exports